import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router';
import { Application } from 'src/config/const/enums';
import useBackListener from 'src/hooks/useBackListener.ts';
import usePreQualification from 'src/hooks/usePreQualification';
import usePreQualificationPages from 'src/hooks/usePreQualificationPages';
import useSharedData from 'src/hooks/useSharedData';
import { PATH_CONTACT_CENTER, PATH_ONLINE } from 'src/routes/paths';
//* ----------------------------------------------------------------

export default function JWTPageGuard({ children }) {
  const { pathname } = useLocation();
  const { funcs } = usePreQualificationPages();
  const { dataSet } = usePreQualification();
  const { application } = { ...dataSet };
  const { accessToken } = useSharedData();

  const pageIndex = { ...children }.props.pageIndex;
  useEffect(() => {
    const backToQuotePoint = (application) => {
      const currentDomain = window.location.origin;

      switch (application) {
        case Application.ONLINE: {
          window.location.href = `${currentDomain}${PATH_ONLINE.gettingStarted}`;
          break;
        }
        case Application.CONTACT_CENTER: {
          window.location.href = `${currentDomain}${PATH_CONTACT_CENTER.openingScript}`;
          break;
        }
      }
    };
    async function initialize() {
      try {
        if (accessToken == null) {
          // The accessToken is not present in the sharedContext then redirect back to login page
          backToQuotePoint(application);
        }
      } catch (err) {
        console.error('Error occurred while reading the JWT token - ', err);
      }
    }
    initialize();
  }, [pathname, accessToken, application]);

  const navType = useBackListener();

  // Ensure we are allowed to navigate to the requested page
  const responsePage = funcs.getRequestPage({
    requestPageIndex: pageIndex,
    navType: navType,
  });
  // Check if this is a navigation 'back'
  if (responsePage.allowPageRequest === false || responsePage.isBack === true) {
    return <Navigate to={responsePage.responsePage.previousRoutePath} />;
  }

  // No issue, load the page.
  return <>{children}</>;
}
